module.exports = __webpack_public_path__ + "static/media/rotor-front.5412b52e.svg";